module.exports = __webpack_public_path__ + "static/media/mail-icon-black.8f874b65.svg";